import { NextPage } from "next";
import { NextSeo } from "next-seo";
import React from "react";
import { useIntl } from "react-intl";

import Cart from "../../../components/ecommerce/Cart";
import Layout from "../../../components/layouts/Default";
import { NEXT_SEO_HIDDEN_CONFIG } from "../../../seo/seo";

const CartPage: NextPage = () => {
  const { formatMessage } = useIntl();

  return (
    <Layout>
      <NextSeo
        {...NEXT_SEO_HIDDEN_CONFIG}
        title={formatMessage({ id: "pageTitles.cart" })}
      />
      <Cart />
    </Layout>
  );
};

export default CartPage;
